import {MaterialDesignContent} from "notistack"
import {styled} from "@mui/material";

export const StyledSuccessSnackbar = styled(MaterialDesignContent)(({theme}) => ({
	"&.notistack-MuiContent-success": {
		backgroundColor: theme.palette.success.constrast,
		border: `1px solid ${theme.palette.success.dark}`,
		color: theme.palette.success.light,
		fontWeight: 600
	}
}));

export const StyledErrorSnackbar = styled(MaterialDesignContent)(({theme}) => ({
	"&.notistack-MuiContent-error": {
		backgroundColor: theme.palette.background.alert.error,
		border: `1px solid ${theme.palette.error.dark}`,
		fontWeight: 600
	}
}));

export const StyledInfoSnackbar = styled(MaterialDesignContent)(({theme}) => ({
	"&.notistack-MuiContent-info": {
		backgroundColor: '#0B141D',
		border: '1px solid #3A3A3A',
		fontWeight: 600
	}
}));